<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <EnterprieSidebarMenu :show_menu="false" :show_back_button="true" back_link="EnterprisePathwayProgressPathwayLists"></EnterprieSidebarMenu>
      
      <div class="content-wrapper padding-left-165">
        <div class="container-wrapper center ml-2">
            <div class="modal-custom overlay" v-show="showOverlay" >
              <div class="loader-img-center">
                <i class="fa fa-spinner fa-spin"></i> Please wait...
              </div>
            </div>
          <iframe id="pdf-frame" style="display: none;"></iframe>

          <div class="row mt-3 mb-3 border-bottom pb-2">
            <div class="col-9 float-left text-left pl-0">
              <div class="h4 text-uppercase">Progress Reports</div>
            </div>
            <div class="col-3 float-right text-right pr-0" >
              <div v-if="results.length > 0" class="margin-t-2 float-right pl-2" @click="shareButtonModal()">
                <img class="cursor-pointer" src="@/assets/Send_Report_Button.svg" alt="MentorMentee" width="24px" />
              </div>

              <div v-if="results.length > 0" class="pl-2 float-right margin-r-10">
                <i class="fa fa-print cursor-pointer pt-0 font-30" aria-hidden="true" @click="printFunc()" ></i>
              </div>
              <div v-if="results.length > 0" class="margin-t-2 float-right pl-2 mr-2" @click="downloadFunc()">
                <img class="cursor-pointer" src="@/assets/Download_Report.svg" alt="MentorMentee" width="24px"  />
              </div>
              <div class="clear"></div>
            </div>
          </div>


        <div class="row " v-if="loading == true">
            <div class="col-3 pl-0 text-left">
              <PuSkeleton :count="1" width=""></PuSkeleton>
            </div>
            <div class="col-5 pl-0">
            </div>
            <div class="col-4 pl-0 pr-0">
              <PuSkeleton :count="1"></PuSkeleton>
            </div>
        </div>

        <div class="text-center pt-4" v-if="loading == true">
          <div class="row" v-for="option in 5">
            <div class="field_11 p-0"><PuSkeleton :count="1"></PuSkeleton></div>
            <div class="field_11" ><PuSkeleton :count="1"></PuSkeleton></div>
            <div class="field_11" ><PuSkeleton :count="1"></PuSkeleton></div>
            <div class="field_11" ><PuSkeleton :count="1"></PuSkeleton></div>
            <div class="field_11" ><PuSkeleton :count="1"></PuSkeleton></div>
            <div class="col-12 p-0">
              <div class="custom_hr"></div>
            </div>
          </div>
        </div>


        <div class="row" v-if="loading == false">
          <div class="col-md-12 p-0">
              <div class="row pb-2" style="border-color: #ced4da !important;">
                <div class="col-2 pt-2">
                  # of Mentees: {{ menteeCount }}
                </div>
                <div class="col-6 pl-0" style="max-width: 48% !important;">
                  
                </div>
                <div class="col-3 pl-0" style="max-width: 31% !important;">
                  <b-form-select
                      class="search_org_text location-custom-select"
                      name="account"
                      id="account"
                      v-model="account_id"
                      :options="account_options"
                      @change="fetchListitems">
                  </b-form-select>
                </div>
                <div class="col-2 text-right search-icon-wrapper cursor-pointer" style="max-width: 10% !important; margin-top: 2px !important; ">
                  <button type="button" class="float-right btn btn-sm ma-blue-btn" @click="fetchListitems()">Filter</button>
                </div>
              </div>

          </div>
        </div>          

          <div>
            <div class="row report_heading" v-if="loading == false">
              <div class="field_1 pl-0">Mentee Name</div>
              <div class="field_2">Current Step</div>
              <div class="field_3" v-for="(option) in steps" :style="'width:' + stepWidth + '%;'">
                {{ option.stepTitle }}
              </div>
              <div class="field_9">Overall Completion</div>
              <div class="col-12 p-0">
                <div class="custom_heading_hr"></div>
              </div>
            </div>


            <div class="row report_view" v-if="loading == false && results.length == 0">
              <div class="col no-record"> {{ message }} </div>
            </div>

            <div class="row report_view" v-for="(result, rindex) in results" :key="rindex" v-if="loading == false">
              <div class="field_1" @click="viewDetailReport(result.menteeId, result.accountId)">{{ result.menteeName }}</div>
              <div class="field_2">{{ result.currentStep }}</div>
              <div class="field_3" v-for="(step, sindex) in result.steps" :style="'width:' + stepWidth + '%;'">
                {{ step.stepStatus }}
              </div>
              <div class="field_9 text-align-right">{{ result.overall }}</div>
              <div class="col-12 p-0">
                <div class="custom_hr"></div>
              </div>
            </div>
          </div>
          <div class="row" v-if="loading == false">
          <div class="col-md-12">
            <div class="row col-12 override-padding pb-2" style="border-color: #ced4da; !important">
              <div class="col-5 pl-0 pt-5">
                # of Mentees: {{ menteeCount }}
              </div>
              <div class="col-7 pl-0">
              </div>
            </div>
          </div>          
          </div>

        </div>

      </div>
    </div>

    <ShareReportModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Share Report</h3></div>
      <div slot="body">
        <div v-if="showShareSuccess == true" class="col-12 override-padding success_msg">
          <b>Report shared successfully!</b>
        </div>
        <div class="col-12 override-padding">
          <input v-model="share_email"
                name="share_email"
                placeholder="Enter Email..."
                class="col-lg-12 input-text form-control input-height-35" 
                v-validate="'required|email'"
                data-vv-as="Email address"
                maxlength="255"
                @keyup="checkEmail()" />
         <div v-show="verrors.has('share_email')" class="validate-warning-msg">{{ verrors.first('share_email') }}</div>
        </div>
        <div class="clear margin-bottom-10"></div>


        <!-- <div v-if="showWait == false" class="col-12 override-padding text-align-right">
          <button
              v-on:click="shareButtonSubmit()"
              class="btn btn-dard-grey col-lg-3"
              ><b>{{ submit_text }}</b></button>
        </div>
        <div v-if="showWait == true" class="col-12 override-padding text-align-right">
          <button
              
              class="btn btn-dard-grey col-lg-3"
              ><b>Please wait...</b></button>
        </div> -->

        <div v-if="showWait == false" class="col-12 override-padding text-align-right">
            <button :disabled="share_button_disable" v-on:click="shareButtonSubmit()"
                class="btn col-3 input-height-25 ma-blue-btn"
                ><b>{{ submit_text }}</b></button>
        </div>
        <div v-if="showWait == true" class="col-12 override-padding text-align-right">
            <button disabled="true" class="btn btn-dard-grey col-lg-3"
                ><b>Please wait...</b></button>
        </div>

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </ShareReportModal>

    <BatchModal :isModalVisible="isExportModalVisible" @close="isExportModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"></div>
      <div slot="body">
        <div class="">
          <div class="export-details">
            Exported: {{ rowsExportedCSV }} of {{ rowsCSV}}
          </div>
          <div class="percentage-text">
            {{ percentage }}
          </div>
          <div class="batch-box">
            <div class="batch-loading" id="batch-loading" >
              &nbsp;
            </div>
          </div>
          <div class="download-link" @click="downloadFunc()" v-if="percentage == '100%'">
            Download CSV File
          </div>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding"></div>
    </BatchModal>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
// import VeeValidate from 'vee-validate';
import UserMenu from '../shared/user_menu.vue';
import EnterprieSidebarMenu from '@/components/shared/enterpriseadmin_sidebar_menu.vue';
import ShareReportModal from '../enterpriseadmin/share_email_report_modal.vue';
import BatchModal from '../admin/reports/report_loading_modal.vue';
import { checkIsManager, checkIsMentor } from '@/components/shared/utils.js';

// Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  components: {
    UserMenu,
    EnterprieSidebarMenu,
    ShareReportModal,
    BatchModal,
  },
  data() {
    return {
      loading: false,
      results: [],
      apiUrl: '',
      isModalVisible: false,
      accountId: '',
      account_options: [],
      submit_text: 'Submit',
      share_email: '',
      showOverlay: false,
      showWait: false,
      showShareSuccess: false,
      isExportModalVisible: false,
      percentage: '0%',
      fileName: '',
      totalCSVPages: 0,
      perCSVPage: 500,
      rowsCSV: 0,
      rowsExportedCSV: 0,
      currentCSVPage: 1,
      share_button_disable: true,
      pathway_options: [],
      pathwayId: '',
      stepCount: 0,
      stepWidth: 0,
      message: '',
      steps: [],
      pdf_file_name: '',
      menteeCount: '',
      account_options: [],
      account_id: '',
    }
  },
  methods: {
    viewDetailReport: function(id, accountId) {
       let routeData = this.$router.resolve({path: '/enterpriseadmin/pathway-progress-report-details/' + accountId + '/' + id + '/' + this.pathwayId});
        window.open(routeData.href, '_self');
    },

    checkEmail: function () {
      if ((this.verrors.items.length === 0)) {
        this.share_button_disable = false;
      }
      else {
        this.share_button_disable = true;
      }
    },
    fetchListitems() {
      this.loading = true;
      this.message = '';
      this.steps = [];
      axios('/desktop/v2/ea/account_pathway_report', {
        method: 'GET',
        params: {
          pathway_id: this.pathwayId,
          account_id: this.account_id,
        }
      })
      .then(response =>  {
          this.loading = false;
          this.results = response.data.data;
          if(this.results.length == 0) {
            this.message = 'No mentees found!';
          }
          this.stepCount = response.data.stepCount;
          this.stepWidth = response.data.stepWidth;
          this.steps = response.data.steps;
          this.menteeCount = response.data.menteeCount;
      })
      .catch(function() { });
    },

    downloadFunc: function() {

      this.showOverlay = true;
      axios('/desktop/v2/ea/account_pathway_pdf_report', {
        method: 'GET',
        params: {
          pathway_id: this.pathwayId,
          account_id: this.account_id,
        }
      })
      .then(response =>  {
          this.pdf_file_name = response.data.pdf_file_name;
          this.showOverlay = false;
          var url = this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name;
     
          //Create XMLHTTP Request.
          var req = new XMLHttpRequest();
          req.open("GET", url, true);
          req.responseType = "blob";
          req.onload = function () {
              //Convert the Byte Data to BLOB object.
              var blob = new Blob([req.response], { type: "application/octetstream" });

              //Check the Browser type and download the File.
              var isIE = false || !!document.documentMode;
              if (isIE) {
                  window.navigator.msSaveBlob(blob, fileName);
              } else {
                  var url = window.URL || window.webkitURL;
                  var link = url.createObjectURL(blob);
                  var a = document.createElement("a");
                  a.setAttribute("download", "progress_report.pdf");
                  a.setAttribute("href", link);
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
              }
          };
          req.send();
          return false;
        })
        .catch(function(error) {
            console.log(error);
        });


    },
    printFunc: function() {
      axios('/desktop/v2/ea/account_pathway_pdf_report', {
        method: 'GET',
        params: {
          pathway_id: this.pathwayId,
          account_id: this.account_id,
        }
      })
      .then(res =>  {
          this.pdf_file_name = res.data.pdf_file_name;
          this.showOverlay = false;
          fetch(this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name).then(function(response) {
              return response.blob();
          }).then(function(myBlob) {
              var objectURL = URL.createObjectURL(myBlob);
              document.querySelector('#pdf-frame').src = '';
              document.querySelector('#pdf-frame').src = objectURL;
              objectURL = URL.revokeObjectURL(myBlob);
          }).then(
              function() {
                  window.setTimeout(function() {
                      document.querySelector('#pdf-frame').contentWindow.print();
                  }, 1000)
              });
            return false;
        })
        .catch(function(error) {
            console.log(error);
        });
    },


            shareButtonSubmit: function() {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                  this.submit_text = 'Please wait...';
                  this.showWait = true;
                  axios('/desktop/v2/ea/account_pathway_pdf_email_report',
                     {
                       method: 'POST',
                       data:
                        {
                          email: this.share_email,
                          pathway_id: this.pathwayId,
                          account_id: this.account_id,
                        },
                     }
                   )
                  .then((resp) => {
                    this.share_email = '';
                    this.submit_text = 'Submit';
                    this.showWait = false;
                    this.showShareSuccess = true;
                    setTimeout(() => {
                        this.showShareSuccess = false;
                    }, 5000)
                    //this.isModalVisible = false;
                    //this.$emit('close');

                   })
                  .catch(error => {

                  });
                }
              });

            },
    shareButtonModal() {
      this.isModalVisible = true;
    },
  },
  created() {
    this.loading = true;
    this.message = '';
    this.apiUrl = process.env.API_ENDPOINT;
    this.pathwayId = this.$route.params.pathway_id;
    this.fetchListitems();
    axios('/enterprise-admin/getAllLinkedLocations',
    {
        method: 'GET'
    })
    .then(response => {
        this.account_options.push({ text:'Filter Location', value: '' });
        for (var m = 0; m < response.data.locations.length; m++) {
            this.account_options.push({ 
                text: response.data.locations[m].company_name, 
                value: response.data.locations[m].id 
            });
        }
        
        
    })
    .catch(() => {
    });







  }
}
</script>

<style scoped>
.report_heading {   
    font-size: 14px; 
    padding-top: 8px;
    padding-bottom: 8px;
    font-weight: bold;
}
.custom_heading_hr, .custom_hr {
  width: 100%;
  margin: 5px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.custom_heading_hr {
    border-bottom: 3px solid #A3A3A3;
}
.field_1, .field_2 {
  width: 17%;
  padding-left: 15px;
}
.report_view .field_1 {
  
}
.field_3 {
  width: 15%;
  text-align: left;
}
.field_9 {
  width: 10.33%;
  text-align: center;
  padding-right: 0px;
}
.btn:disabled {
    background-color: #8b8b8b;
    color: #FFF;
}
.report_view {
  min-height: 40px;
  font-weight: bold;
}
.report_view .field_1 {
  cursor:pointer; padding-left: 0!important;
}
.success_msg {
  color: #68C47E; text-align: center; margin-bottom: 15px;
}
.btn-dard-grey, .btn-red {
  line-height: 30px; border-radius: 10px;  
}
.overlay {
  opacity: .9
}
.font-30 {
  font-size: 30px;
}
.field_11 {
  width: 20%; padding-left: 15px;
}
.no-record {
  font-style: italic; font-weight: normal;
}
.ma-blue-btn, .ma-blue-btn:focus, .ma-blue-btn:active, .ma-blue-btn:hover {
  color: #FFF !important; 
  font-weight: 500;
  width: 100%;
  border-radius: 15px;
}
.search_org_text { width: 95%;outline: 0; border: 1px solid #ced4da; background-color: #FFF; border-radius: 10px; height: 32px; padding: 0.375rem 1.75rem 0.375rem 0.75rem; }
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/pathway_progress_report.vue